import React, { Component } from "react"
import { connect } from "react-redux";
import Header from "../../components/header";
import { RandomPassword } from "../../services/common/action";
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

 
class RandomPin extends Component {
    constructor(props) {
 
        super(props)
        this.state = {
            randomPin: "",
            loginDetails :""
        };
    }


    handleChange = (e) => {
        e.preventDefault();
        this.setState({ randomPin: e.target.value });
    };


    componentDidMount() {
 
        let loginDetails = this.props.forgotPasswordDetails
         this.setState({
            loginDetails
        })

    
   }

 

    handleLogin = (e) => {
        e.preventDefault();
 
        var payLoad = {
            "oldPassword":this.state.randomPin,
            "username" : this.state.loginDetails
         };

         this.props.RandomPassword(payLoad);
   }
   
 


  componentWillReceiveProps = nextProps => {

    if (nextProps.randomPassStatus === true) {
        //toast.success(nextProps.message);
      
        this.props.history.push("/CreateNewpassword")
    } else {
       toast.error(nextProps.message);
    }
  };

  goBack = (e) =>{
      e.preventDefault();
      this.props.history.push("/AdminHome")
  }
    render() {

        return (
            <>

                <Header status={"beforeLogin"} />
                 <div className="login-wrapper">

                    <div className="container-fluid">
                        <div className="login-bg">

                            <div className="login-form">

                                <h1>Please Enter OTP</h1>


                                <form className="login-form"  onSubmit={this.handleLogin}>
                                    <div className="form-group">
                                        <input type="text" onChange={this.handleChange}
                                            name="randomPin" value={this.state.randomPin} placeholder="OTP" />
                                        <span className="error">This value is required</span>
                                    </div>
                                    <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                    <div className="form-group">
                                        <button type="submit"  className="loginbtn-submit green">Submit</button>
                                    </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                    <div className="form-group">
                                     
                                        <button type="button" onClick={this.goBack}  className="loginbtn-submit green">cancel</button>
                                        
                                    </div>
                                    </div>
                                    </div>
                                   
                                    
 
                                  
 
                                </form>
                            </div>
                        </div>


                    </div>

                </div>
                <div className="footer-section postRelative">
                    <div className="container">
                        <div className="row text-center">
                            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-6">
                                <ul className="disclaimers">
                                    <li>About us</li>
                                </ul>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-6">
                                <ul className="disclaimers">

                                    <li>Resources</li>

                                </ul>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-6">
                                <ul className="disclaimers">
                                    <li>Help</li>
                                </ul>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-6">
                                <ul className="disclaimers">
                                    <li>Legal Disclaimers</li>
                                </ul>
                            </div>
                        </div>

                    </div>

                </div>
            </>
        )
    }
}
const mapStateToProps = state => ({
    randomPassStatus: state.commonReducer.randomPassStatus,
    randomPassDetails: state.commonReducer.randomPassDetails,
    message: state.commonReducer.message,
    forgotPasswordDetails : state.commonReducer.forgotPasswordDetails
});

const mapDispatchToProps = dispatch => ({
    RandomPassword: payLoad => dispatch(RandomPassword(payLoad))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RandomPin);
 